import { IBuxtonSupportTeamMember, IServiceResult } from "../Models/Models";

export interface ICompanySupportTeamAxios {
  GetCompanySupportTeam(): Promise<
    IServiceResult<Array<IBuxtonSupportTeamMember>>
  >;
}
